module.exports = __webpack_public_path__ + "media/images/banner/zh-hant/banner-b40e108b4bfc967b4509d8151ce8f6ff.jpg";